module.exports = __webpack_public_path__ + "static/img/my_data.13363971.png";